"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const EmailAddressTooltip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'If you do not want your personal email address to show in Public Work Search, you may choose to create an email ' +
        'specifically for use in the Public Work Search. Please note that if someone reaches out to you about a work, the ' +
        'email you provide for the Public Contact is where their communication will go.', place: 'right' }));
exports.default = EmailAddressTooltip;
